<template>
  <div class="animated fadeIn">

    <!-- Info and Map -->
    <b-row>
      <b-col lg="8" offset="2">
        <b-card class="information" header="data">
          <div slot="header">
            <h5 style="display: inline;" class="card-title mb-0">Information</h5>
          </div>
          <div style="min-height: 403px">
            <span class="title-details">
              Company :
              <b>{{cityData.company}}</b>
            </span>
            <span class="title-details">
              Location :
              <b>{{cityData.location}}</b>
            </span>
            <span class="title-details">
              Contact :
              <b>{{cityData.contact}}</b>
            </span>
            <span class="title-details">
              Address :
              <b>{{cityData.address1}}, {{cityData.clientZip}}</b>
            </span>
            <span class="title-details">
              Phone :
              <b>{{cityData.clientPhone}}</b>
            </span>
            <span class="title-details">
              Email :
              <b>{{cityData.clientEmail}}</b>
            </span>
            <div v-show="loadingCity" class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>
            <gmap-map
              v-if="!loadingMap"
              :center="center"
              :options="mapOptions"
              style="width:100%;  height: 160px;margin-top:25px">
              <gmap-marker :key="key" v-for="(item, key) in center" :position="getPosition(item)"></gmap-marker>
            </gmap-map>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!--Charts -->
    <b-row v-if="propsReady">
      <ChartNormal
      size="6"
      offset="0"
      title="Active Backlog"
      chart="column"
      chartType="backlog"
      :withDate="false"
      :withFinancial="false"
      :city="locationParam"
      :cityName="cityParam"/>
      <ChartNormal
      size="6"
      offset="0"
      title="Delivered Equipment"
      chart="pie"
      chartType="Shipped"
      :withDate="true"
      :withFinancial="true"
      :city="locationParam"
      :cityName="cityParam"/>
      <ChartStacked
      size="6"
      offset="0"
      title="Historical Data"
      chartType="historical"
      :withDate="false"
      :withFinancial="false"
      :city="locationParam" />
      <ChartNormal
      size="6"
      offset="0"
      title="Beyond Economical Repair"
      chart="column"
      chartType="BER"
      :withDate="true"
      :withFinancial="false"
      :city="locationParam"
      :cityName="cityParam"/>
    </b-row>

  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartNormal from "../../components/chart/chartNormal";
import ChartStacked from "../../components/chart/chartStacked";

export default {
  name: "dashboard",
  props: ["loc", "city", "lat", "lng"],
  components: {
    ChartNormal,
    ChartStacked,
    highcharts: Chart
  },
  data: function() {
    return {
      propsReady: false,
      locationParam: "",
      cityData: [],
      cityParam: "",
      mapOptions: {
        zoom: 7,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        draggable: false
      },
      center: { lat: null, lng: null },
      loadingMap: true
    };
  },

  methods: {
    fetchCityData() {
      let params = {};
      params = {
        client: this.locationParam
      };
      this.$http
        .get("https://www.fibernode.com/api/profile/clientInfo.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            this.cityData = res.data;
            this.loadingCity = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    getPosition: function(marker) {
      return {
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng)
      };
    }
  },
  mounted() {
    this.locationParam = this.loc;
    this.cityParam = this.city;
    this.center.lat = parseFloat(this.lat);
    this.center.lng = parseFloat(this.lng);
    this.loadingMap = false;
    this.fetchCityData();
    this.propsReady = true;
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
</style>
